<template>
  <div id="membership_main">
    <div class="mem_back_color">
      <video class="mem_pc" autoplay muted playsinline src="../assets/img/mem/memtop.mp4"></video>
      <video class="mem_mobile" autoplay muted playsinline src="../assets/img/mem/memtop_m.mp4"></video>
    </div>

    <div class="mem_tabbutton mem_tab_pc">
      <ul class="mem_tab_ul">
        <li class="mem_tab mem_active" data-target="mem_sec_1">
          <img class="memtab_no" src="../assets/img/mem/tab_button_img.png" alt="">
          <img class="memtab_on" src="../assets/img/mem/click_tab.png" alt="">
        </li>

        <li class="mem_tab" data-target="mem_sec_2">
          <img class="memtab_no" src="../assets/img/mem/tab_button_img1.png" alt="">
          <img class="memtab_on" src="../assets/img/mem/click_tab1.png" alt="">
        </li>

        <li class="mem_tab" data-target="mem_sec_3">
          <img class="memtab_no" src="../assets/img/mem/tab_button_img2.png" alt="">
          <img class="memtab_on" src="../assets/img/mem/click_tab2.png" alt="">
        </li>

        <li class="mem_tab" data-target="mem_sec_4">
          <img class="memtab_no" src="../assets/img/mem/tab_button_img3.png" alt="">
          <img class="memtab_on" src="../assets/img/mem/click_tab3.png" alt="">
        </li>

        <li class="mem_tab" data-target="mem_sec_5">
          <img class="memtab_no" src="../assets/img/mem/tab_button_img4.png" alt="">
          <img class="memtab_on" src="../assets/img/mem/click_tab4.png" alt="">
        </li>

        <li class="mem_tab" data-target="mem_sec_6">
          <img class="memtab_no" src="../assets/img/mem/tab_button_img5.png" alt="">
          <img class="memtab_on" src="../assets/img/mem/click_tab5.png" alt="">
        </li>
      </ul>
    </div>

    <div class="mem_tabbutton mem_tab_mobile mem_mobile_slide">
      <ul class="mem_tab_ul mem_tab_slide">
        <li class="mem_tab mem_active" data-target="mem_sec_1">
          <img class="memtab_no" src="../assets/img/mem/tab_button_img_mobile.png" alt="">
          <img class="memtab_on" src="../assets/img/mem/click_tab_mobile.png" alt="">
        </li>

        <li class="mem_tab" data-target="mem_sec_2">
          <img class="memtab_no" src="../assets/img/mem/tab_button_img1_mobile.png" alt="">
          <img class="memtab_on" src="../assets/img/mem/click_tab1_mobile.png" alt="">
        </li>

        <li class="mem_tab" data-target="mem_sec_3">
          <img class="memtab_no" src="../assets/img/mem/tab_button_img2_mobile.png" alt="">
          <img class="memtab_on" src="../assets/img/mem/click_tab2_mobile.png" alt="">
        </li>

        <li class="mem_tab" data-target="mem_sec_4">
          <img class="memtab_no" src="../assets/img/mem/tab_button_img3_mobile.png" alt="">
          <img class="memtab_on" src="../assets/img/mem/click_tab3_mobile.png" alt="">
        </li>

        <li class="mem_tab" data-target="mem_sec_5">
          <img class="memtab_no" src="../assets/img/mem/tab_button_img4_mobile.png" alt="">
          <img class="memtab_on" src="../assets/img/mem/click_tab4_mobile.png" alt="">
        </li>

        <li class="mem_tab" data-target="mem_sec_6" style="margin-right:2px;">
          <img class="memtab_no" src="../assets/img/mem/tab_button_img5_mobile.png" alt="">
          <img class="memtab_on" src="../assets/img/mem/click_tab5_mobile.png" alt="">
        </li>
      </ul>
    </div>
    <div>
      <!-- 섹션 -->
      <div class="mem_coupon motion_right mem_sec_1 mem_section mem_sec_mobile_padding"
        :class="{ visible: isVisible1 }">
        <img class="mem_coupon_font mem_pc" src="../assets/img/mem/mem_coupon_font.jpg">
        <img class="mem_coupon_font mem_mobile" src="../assets/img/mem/mem_coupon_font_m.jpg">
        <video class="mem_coupon_video mem_pc" src="../assets/img/mem/mem_2900.mp4" autoplay muted loop
          playsinline></video>
        <video class="mem_coupon_video mem_mobile" src="../assets/img/mem/mem_2900_m.mp4" autoplay muted loop
          playsinline></video>
      </div>

      <div class="mem_coupon motion_right mem_sec_2 mem_section mem_sec_mobile_padding"
        :class="{ visible: isVisible2 }">
        <video class="mem_coupon_video mem_pc" src="../assets/img/mem/mem_coupon.mp4" autoplay muted loop
          playsinline></video>
        <video class="mem_coupon_video mem_mobile" src="../assets/img/mem/mem_coupon_m.mp4" autoplay muted loop
          playsinline></video>
        <img class="mem_coupon_font mem_pc" src="../assets/img/mem/mem_coupon_font1.jpg">
        <img class="mem_coupon_font mem_mobile" src="../assets/img/mem/mem_coupon_font1_m.jpg">
      </div>

      <div class="mem_coupon title_motion mem_sec_3 mem_section mem_sec_mobile_padding"
        :class="{ visible: isVisible3 }">
        <img class="mem_coupon_font mem_pc" src="../assets/img/mem/mem_coupon_font2.jpg">
        <img class="mem_coupon_font mem_mobile" src="../assets/img/mem/mem_coupon_font2_m.jpg">
        <video class="mem_coupon_video mem_pc" src="../assets/img/mem/mem_sale.mp4" autoplay muted loop
          playsinline></video>
        <video class="mem_coupon_video mem_mobile" src="../assets/img/mem/mem_sale_m.mp4" autoplay muted loop
          playsinline></video>
      </div>

      <div class="mem_coupon motion_right mem_sec_4 mem_section mem_sec_mobile_padding"
        :class="{ visible: isVisible4 }">
        <video class="mem_coupon_video mem_pc" src="../assets/img/mem/mem_new.mp4" autoplay muted loop
          playsinline></video>
        <video class="mem_coupon_video mem_mobile" src="../assets/img/mem/mem_new_m.mp4" autoplay muted loop
          playsinline></video>
        <img class="mem_coupon_font mem_pc" src="../assets/img/mem/mem_coupon_font3.jpg">
        <img class="mem_coupon_font mem_mobile" src="../assets/img/mem/mem_coupon_font3_m.jpg">
      </div>

      <div class="mem_coupon title_motion mem_sec_5 mem_section mem_sec_mobile_padding"
        :class="{ visible: isVisible5 }">
        <img class="mem_coupon_font mem_pc" src="../assets/img/mem/mem_coupon_font4.jpg">
        <img class="mem_coupon_font mem_mobile" src="../assets/img/mem/mem_coupon_font4_m.jpg">
        <video class="mem_coupon_video mem_pc" src="../assets/img/mem/mem_coin.mp4" autoplay muted loop
          playsinline></video>
        <video class="mem_coupon_video mem_mobile" src="../assets/img/mem/mem_coin_m.mp4" autoplay muted loop
          playsinline></video>
      </div>

      <div class="mem_coupon motion_right mem_sec_6 mem_section mem_sec_mobile_padding"
        :class="{ visible: isVisible6 }">
        <video class="mem_coupon_video mem_pc" src="../assets/img/mem/mem_chiar.mp4" autoplay muted loop
          playsinline></video>
        <video class="mem_coupon_video mem_mobile" src="../assets/img/mem/mem_chiar_m.mp4" autoplay muted loop
          playsinline></video>
        <img class="mem_coupon_font mem_pc" src="../assets/img/mem/mem_coupon_font5.jpg">
        <img class="mem_coupon_font mem_mobile" src="../assets/img/mem/mem_coupon_font5_m.jpg">
      </div>
    </div>


    <div class="proimg_jp_su">
      <div class="jpprotit_su">
        <img class="memtop2_mobile" src="../assets/img/mem/memtop2.png" alt="">
      </div>

      <div class="jpproimg_su">
        <div class="jpprdfst_su">
          <a href="bustour?nt=JP&ar=HOK">
            <img class="jppd1_su" src="../assets/img/mem/product1.png" alt="">
          </a>
          <a href="bustour?nt=JP&ar=OSA">
            <img class="jppd2_su" src="../assets/img/mem/product2.png" alt="">
          </a>
          <a class="jmi1_su" href="bustour?nt=JP&ar=HOK">
            <img class="jmi1_su" src="../assets/img/mem/jppdimg_mo1.png" alt="">
          </a>
          <a class="jmi2_su" href="bustour?nt=JP&ar=OSA">
            <img class="jmi2_su" src="../assets/img/mem/jppdimg_mo2.png" alt="">
          </a>
        </div>

        <div class="jpprdsec_su">
          <a href="bustour?nt=JP&ar=FUK">
            <img class="jppd3_su" src="../assets/img/mem/product3.png" alt="">
          </a>
          <a href="bustour?nt=JP&ar=NAG">
            <img class="jppd4_su" src="../assets/img/mem/product4.png" alt="">
          </a>
          <a class="jmi3_su" href="bustour?nt=JP&ar=FUK">
            <img class="jmi3_su" src="../assets/img/mem/jppdimg_mo3.png" alt="">
          </a>
          <a class="jmi4_su" href="bustour?nt=JP&ar=NAG">
            <img class="jmi4_su" src="../assets/img/mem/jppdimg_mo4.png" alt="">
          </a>
        </div><!-- jpprdsec -->

        <div class="jpprdthr_su">
          <a href="bustour?nt=JP&ar=YAM">
            <img class="jppd6_su" src="../assets/img/mem/product6.png" alt="">
          </a>
          <a href="bustour?nt=JP&ar=TYO">
            <img class="jppd7_su" src="../assets/img/mem/product7.png" alt="">
          </a>
          <a class="jmi6_su" href="bustour?nt=JP&ar=YAM">
            <img class="jmi6_su" src="../assets/img/mem/jppdimg_mo6.png" alt="">
          </a>
          <a class="jmi7_su" href="bustour?nt=JP&ar=TYO">
            <img class="jmi7_su" src="../assets/img/mem/jppdimg_mo7.png" alt="">
          </a>
        </div>
      </div>
    </div>

    <div class="msr_term_su">
      <div class="termtxt_su">
        <p class="termmain_su"><i class="bi bi-exclamation-circle"></i> &nbsp;엔데이트립 멤버십 약관</p>
        <div class="alltext_su">
          <p>- 본 약관은 엔타비글로벌(주)(이하 "당사")에서 제공하는 여행 상품 브랜드 "엔데이트립 멤버십 서비스"(이하 "멤버십")의 약관입니다.</p>
          <p>- 멤버십 가입 상품의 판매, 회원가입, 멤버십 서비스는 당사에서만 제공하며 당사가 진행한 이외의 경로를 통한 멤버십 상품의 구매, 회원가입, 멤버십 서비스의 제공은 멤버십 효력을 가질 수
            없습니다.</p>
          <p>- 멤버십 가입 상품의 판매는 당사에서만 판매하며 공식 홈페이지 외 온라인 쇼핑몰, 여행 플랫폼 등에서 구매할 수 있습니다. 실제 가입과 서비스의 제공은 당사의 공식 홈페이지(<a
              href="https://ntabi.co.kr/" style="color:#092525;">https://ntabi.co.kr</a>)를 통해 제공됩니다.</p>
          <p>- 멤버십 가입 완료 후 즉시 멤버십 혜택을 이용하실 수 있습니다.</p>
          <p>- 멤버십 가입 비용은 포인트로 결제하실 수 없습니다.</p>
          <p>- 멤버십 가입 시 엔타비글로벌(주), 엔데이트립 공식 홈페이지 회원가입이 포함되며 개인정보취급방침, 이용약관, 여행약관 등 공식 홈페이지에서 제공하는 약관에 동의하는 것으로 간주됩니다.
          </p>
          <p>- 멤버십 가입 시 제공되는 혜택 모두 타인에게 양도가 불가능합니다.</p>
          <p>- 멤버십 가입 시 혜택은 가입자 본인에게만 제공되며 양도 등 본인 외 사용여부 확인을 위해 여권정보(여권사본)을 필수로 수집합니다. 이에 멤버십 가입 시 개인정보수집에 동의한 것으로 간주됩니다.</p>
          <p>- 미성년자의 멤버십 가입의 경우 법정대리인(부모 등)의 동의(인감 날인 동의서, 인감증명서 등의 구비서류 제시)를 얻어야 합니다.</p>
          <p>- 멤버십 가입 완료 후 철회 및 취소, 환불은 일체 불가능합니다.(해외여행결격사유 발생에도 적용)</p>
          <p>- 엔타비글로벌(주), 엔데이트립 공식 홈페이지 회원 탈퇴 시 멤버십도 자동 해지되며 환불되지 않습니다.</p>
          <p>- 여행 상품의 예약(구매)은 엔타비글로벌(주), 엔데이트립 공식 홈페이지에서 가능하며 당사가 입점한 여행 플랫폼, 소셜 커머스 등의 타 채널에서의 구매 시 혜택은 적용되지 않습니다.</p>
          <p>- 멤버십 회원의 경우 엔데이트립 버스투어 탑승 시 회원 본인 확인을 위해 여권 제시가 필수이며, 본인 확인이 불가능 한 경우 탑승을 거부할 수 있습니다.</p>
          <p>- 엔데이트립 버스투어 코스 이용 시 규정은 상품에 명시된 내용을 토대로 동일하게 적용됩니다.</p>
          <p>- 엔데이트립 버스투어 코스 예약 시 해당 일자의 잔여 좌석 유무에 따라 확정됩니다.</p>
          <p>- 코스의 운행 종료는 당사의 사정에 의해 사전에 고지 없이 종료될 수 있습니다.</p>
          <p>- 본 약관은 수시로 개정 가능하며, 개정하고자 할 경우 개정하고자 하는 날로부터 15일 이전에 약관이 개정된다는 사실과 개정된 내용 등을 다음의 방법 중 1가지 이상의 방법으로 회원에게
            통지합니다. <br>
            (단, 회원에게 불리하게 약관이 변경되는 경우 최소 30일 이상의 유예기간을 두고 사전고지 합니다.)<br>
            &nbsp;&nbsp; a. e-mail 통보, b. SMS 통보, c. 공식 홈페이지 고시, d. 회원이 제공한 연락처 정보 등을 이용한 전화 안내</p>
          <p>- 당사의 사정으로 인해 멤버십 서비스는 중단될 수 있으며 중단하고자 하는 날로부터 최소 30일 이전에 멤버십 서비스 중단 사실을 다음의 방법 중 1가지 이상의 방법으로 회원에게 통지합니다.
            <br>&nbsp;&nbsp; a. e-mail 통보, b. SMS 통보, c. 공식 홈페이지 고시, d. 회원이 제공한 연락처 정보 등을 이용한 전화 안내
          </p>
        </div>
      </div>
    </div>
    <div id="mem_gogo" @click="goToPage('MyPageInfoChange_joinM')">
      <img src="../assets/img/mem/mem_gogo.gif" alt="">
    </div>

    <div class="click_gogo_mem_mobile" @click="goToPage('MyPageInfoChange_joinM')">
      <img src="../assets/img/mem/mem_gogo.gif" alt="">
    </div>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        isVisible1: false,
        isVisible2: false,
        isVisible3: false,
        isVisible4: false,
        isVisible5: false,
        isVisible6: false,
        memTabs: [],
        memSections: [],
        memTabWrapper: null,
        memTabHeight: 100,
        isMobile: false,
      };
    },

    methods: {
      checkDevice() {
        this.isMobile = window.innerWidth <= 1024;
        this.memTabHeight = this.isMobile ? 80 : 100;
      },

      handleScroll() {
        const y = window.scrollY;

        if (this.isMobile) {
          this.isVisible1 = y > 200;
          this.isVisible2 = y > 600;
          this.isVisible3 = y > 1200;
          this.isVisible4 = y > 1800;
          this.isVisible5 = y > 2400;
          this.isVisible6 = y > 3000;
        } else {
          this.isVisible1 = y > 100;
          this.isVisible2 = y > 1450;
          this.isVisible3 = y > 2250;
          this.isVisible4 = y > 3100;
          this.isVisible5 = y > 3900;
          this.isVisible6 = y > 4700;
        }

        const 기준선 = y + this.memTabHeight + 6;
        let currentClass = '';

        this.memSections.forEach(section => {
          if (기준선 >= section.offsetTop) {
            const cls = [...section.classList].find(c =>
              c.startsWith('mem_sec_')
            );
            if (cls) currentClass = cls;
          }
        });

        this.memTabs.forEach(tab => {
          const isActive = tab.dataset.target === currentClass;
          tab.classList.toggle('mem_active', isActive);

          if (isActive && this.isMobile) {
            this.moveTabToCenter(tab);
          }
        });
      },

      onTabClick(e) {
        const tab = e.currentTarget;
        const cls = tab.dataset.target;
        const target = document.querySelector(`.${cls}`);
        if (!target) return;

        window.scrollTo({
          top: target.offsetTop - this.memTabHeight,
          behavior: 'smooth',
        });

        if (this.isMobile) {
          this.moveTabToCenter(tab);
        }
      },

      moveTabToCenter(tab) {
        if (!this.memTabWrapper || !tab) return;

        const wrapper = this.memTabWrapper;

        const wrapperRect = wrapper.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();

        const targetScrollLeft =
          wrapper.scrollLeft +
          (tabRect.left - wrapperRect.left) -
          wrapperRect.width / 2 +
          tabRect.width / 2;

        wrapper.scrollTo({
          left: targetScrollLeft,
          behavior: 'smooth',
        });
      },

      goToPage(path) {
        if (path === 'MyPageInfoChange_joinM') {
          this.$router.push({ path: '/MyPageInfoChange_joinM' });
        }
      },
    },

    mounted() {
      window.addEventListener('scroll', function () {
        const element = document.getElementById('mem_gogo');
        if (!element) return;

        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop < 500) {
          element.style.opacity = '0';
          return;
        }

        element.style.opacity = '1';

        if (scrollTop >= 7950) {
          element.style.opacity = '0';
        }
      });

      this.checkDevice();
      this.memTabs = document.querySelectorAll('.mem_tab');
      this.memSections = document.querySelectorAll('.mem_section');
      this.memTabWrapper = document.querySelector('.mem_tab_slide');

      this.memTabs.forEach(tab =>
        tab.addEventListener('click', this.onTabClick)
      );

      window.addEventListener('scroll', this.handleScroll, {
        passive: true,
      });
      window.addEventListener('resize', this.checkDevice);

      this.handleScroll();

      window.addEventListener('scroll', () => {
        const windowHeight = window.innerHeight;

        document
          .querySelectorAll('.jpprdfst_su, .jpprdsec_su, .jpprdthr_su')
          .forEach(el => {
            if (el.getBoundingClientRect().top < windowHeight - 100) {
              el.classList.add('show');
            }
          });
      });
    },

    beforeUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.checkDevice);
    },
  };
</script>




<style scoped>
  :global(html),
  :global(body) {
    overflow-x: clip;
  }

  .mem_tab_slide {
    display: flex;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;

    padding-left: 50vw;
    padding-right: 50vw;
    box-sizing: content-box;

    overscroll-behavior-x: contain;
  }

  .mem_tab {
    flex-shrink: 0;
  }

  #membership_main {
    margin-top: -56px;
  }

  /* 비디오 */
  .mem_pc,
  .mem_mobile {
    width: 100%;
    display: block;
  }

  .mem_mobile {
    display: none;
  }

  /* 공통 */
  .mem_back_color {
    width: 100%;
    line-height: 0;
  }

  .section_padding {
    padding: 80px 0;
  }

  /* 탭 */
  .mem_tabbutton {
    position: sticky;
    top: 0;
    z-index: 1000;
    background: url(../assets/img/mem/tab_bg.jpg) center no-repeat;
  }

  .mem_tab_ul {
    max-width: 1700px;
    height: 100px;
    margin: 0 auto;
    display: flex;
    padding: 0;
    list-style: none;
  }

  .mem_tab {
    width: 280px;
    height: 100%;
    cursor: pointer;

  }

  .mem_tab.mem_active {
    transition: all 0.2s;
  }

  .mem_tab.mem_active .memtab_on {
    display: block;
  }

  .mem_tab.mem_active .memtab_no {
    display: none;
  }

  .memtab_on {
    display: none;
  }

  .memtab_no {
    display: block;
  }

  .mem_tab_mobile {
    display: none;
  }

  .mem_section {
    height: 800px;
    padding-top: 120px;
  }

  .inner_1500 {
    max-width: 1400px;
    width: 100%;
    margin: 100px auto;
  }

  .inner_1100 {
    max-width: 1100px;
    width: 100%;
    margin: 50px auto;
  }

  .motion_right {
    transform: translateX(500px);
    opacity: 0;
    transition: transform 0.2s ease, opacity 0.1s ease;
  }

  .title_motion {
    transform: translateX(-500px);
    opacity: 0;
    transition: transform 0.2s ease, opacity 0.1s ease;
  }

  /* 스크롤 ↓ */
  .visible {
    transform: translateX(0);
    opacity: 1;
  }

  /* 쿠폰 */
  .mem_coupon {
    display: flex;
    justify-content: space-between;
    max-width: 1400px;
    width: 100%;
    margin: 0 auto;
  }

  .mem_coupon_font {
    width: 52%;
    height: auto;
  }

  .mem_coupon_video {
    width: 46%;
  }

  /* 카드 */
  .glass_wrap {
    display: flex;
    justify-content: space-between;
  }

  .touch_position {
    width: 30%;
    transition: transform 0.3s;
  }

  .touch_position:hover {
    transform: translateY(-20px);
  }

  .bottom_space {
    margin-bottom: 200px;
  }

  #mem_gogo {
    position: fixed;
    cursor: pointer;
    bottom: 15%;
    right: 3%;
    opacity: 0;
    overflow: hidden;
  }

  #mem_gogo:hover {
    transition: all 0.2s;
    transform: translateY(-10px);
  }

  #mem_gogo img {
    width: 150px;
  }

  .click_gogo_mem_mobile {
    display: none;
    position: fixed;
    cursor: pointer;
    width: 14%;
    bottom: 5%;
    right: 13%;
    border-radius: 10px;
    transition: opacity 0.3s;
    opacity: 1;
    transition: all 0.5s;
    overflow: hidden;
  }

  .click_gogo_mem_mobile img {
    width: 100%;
  }

  /* 모바일 */
  @media (max-width: 1024px) {
    #membership_main {
      margin-top: 4.3rem;
    }

    .mem_pc {
      display: none;
    }

    .mem_mobile {
      display: block;
    }

    .mem_tab_pc {
      display: none;
    }

    .mem_tab_mobile {
      display: block;
    }

    .mem_coupon,
    .glass_wrap {
      flex-direction: column;
      gap: 20px;
    }

    .mem_coupon_font,
    .mem_coupon_video,
    .touch_position {
      width: 100%;
    }

    .mem_tab_ul {
      width: 100%;
      height: 80px;
    }

    .mem_tab {
      width: 33%;
    }

    .memtab_no {
      width: 100%;
    }

    .memtab_on {
      width: 100%;
    }

    .mem_mobile_line {
      top: 3.4rem;
    }

    .mem_mobile_line2 {
      height: 76px;
      top: 8.2rem;
    }

    .inner_1500 {
      width: 95%;
    }

    .inner_1500 img {
      width: 100%;
    }

    /* 쿠폰 영역 모바일 정렬 */
    .mem_coupon {
      flex-direction: column;
      align-items: center;
      padding: 50px 0;
    }

    /* 영상 먼저 */
    .mem_coupon_video {
      order: 1;
      width: 95%;
      margin: 0 auto;
    }

    /* 이미지 아래 */
    .mem_coupon_font {
      order: 2;
      width: 95%;
      margin: 0 auto;
    }

    .mem_section {
      padding-top: 0px;
      height: auto;
    }

    .mem_tab_mobile {
      display: block;
      position: sticky;
      top: 3.4rem;
      z-index: 1000;
      background: url(../assets/img/mem/tab_bg.jpg) center no-repeat;
    }

    .mem_tab_slide {
      display: flex;
      gap: 12px;
      height: 80px;
      overflow-x: auto;
      overflow-y: hidden;
      scroll-snap-type: x mandatory;
      -webkit-overflow-scrolling: touch;
    }

    .mem_tab_slide::-webkit-scrollbar {
      display: none;
    }

    .mem_tab {
      flex: 0 0 auto;
      width: 140px;
      height: 100%;
      scroll-snap-align: center;
    }

    .mem_sec_mobile_padding {
      padding-top: 150px;
    }
  }

  .proimg_jp_su {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #daffed;
    ;
    padding-bottom: 100px;
  }

  .proimg_jp_su .jpprotit_su {
    width: 100%;
    text-align: center;
    margin: 5rem auto;
  }

  .proimg_jp_su .jpprotit_su p {
    font-size: 4rem;
    font-weight: bolder;
    margin-top: 8rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .proimg_jp_su .jpproimg_su {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }

  /* 공통 */
  .jpprdfst_su a,
  .jpprdsec_su a,
  .jpprdthr_su a {
    display: inline-block;
    text-align: center;
  }

  /* PC 기본 숨김 */
  .jmi1_su,
  .jmi2_su,
  .jmi3_su,
  .jmi4_su,
  .jmi5_su,
  .jmi6_su,
  .jmi7_su {
    display: none;
  }

  /* 애니메이션 공통 */
  .jpprdfst_su,
  .jpprdsec_su,
  .jpprdthr_su {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 20px;
    opacity: 0;
    transition: all .7s ease;
  }

  .jpprdfst_su {
    transform: translateY(50px);
  }

  .jpprdsec_su {
    transform: translateY(80px);
  }

  .jpprdthr_su {
    transform: translateY(100px);
  }

  .jpprdfst_su.show,
  .jpprdsec_su.show,
  .jpprdthr_su.show {
    opacity: 1;
    transform: translateY(0);
  }

  /* 약관 */
  .msr_term_su {
    width: 100%;
    background-color: #64dada;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #092525;
    padding-top: 5rem;
    font-weight: bold;
  }

  .termtxt_su {
    display: flex;
    flex-direction: column;
    margin: 0 50px 50px;
  }

  .termmain_su {
    font-size: 2rem;
    display: flex;
  }

  /* ================== 반응형 ================== */

  @media (max-width:1023px) {
    .termmain_su {
      font-size: 1.7rem;
    }

    .jpprotit_su {
      margin: 0 auto;
    }

    .proimg_jp_su .jpprotit_su {
      margin: 2rem;
    }

    .memtop2_mobile {
      width: 90%;
      margin: 0 auto;
    }

    .jppd1_su,
    .jppd2_su,
    .jppd3_su,
    .jppd4_su,
    .jppd5_su,
    .jppd6_su,
    .jppd7_su {
      display: none;
    }

    .proimg_jp_su .jpproimg_su {
      padding-inline: 20px;
      gap: 0px;
    }

    .jpprdfst_su img,
    .jpprdsec_su img,
    .jpprdthr_su img {
      width: 100%;
    }
  }

  @media (max-width:599px) {
    .jpproimg_su {
      gap: 0;

    }

    .jpprdfst_su,
    .jpprdsec_su,
    .jpprdthr_su {
      flex-direction: column;
      gap: 0;
    }

    .jpprdfst_su img,
    .jpprdsec_su img,
    .jpprdthr_su img {
      width: 100%;
      margin-top: 20px;
    }

    .jpprdsec_su {
      margin-left: 0;
    }

    .jmi1_su,
    .jmi2_su,
    .jmi3_su,
    .jmi4_su,
    .jmi5_su,
    .jmi6_su,
    .jmi7_su {
      display: inline-block;
    }

    #mem_gogo {
      display: none;
    }

    .click_gogo_mem_mobile {
      display: block;
    }
  }
</style>